import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useSupplyForwardingStatus, SupplyForwardingStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<SupplyForwardingStatus>
    useData={useSupplyForwardingStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
